"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserBtn = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const Person_1 = __importDefault(require("@material-ui/icons/Person"));
const user_btn_styles_1 = require("./user-btn-styles");
const user_context_1 = require("../../../common/user/user-context");
const user_btn_item_1 = require("./user-btn-item");
const react_intl_1 = require("react-intl");
function UserBtn({ actions = [], classOverrides, displayLogoutBtn = true, }) {
    const classes = user_btn_styles_1.useStyles();
    const { user, logout } = react_1.useContext(user_context_1.UserContext);
    const anchorRef = react_1.useRef(null);
    const [opened, setOpened] = react_1.useState(false);
    const openMenu = event_callback_hook_1.useEventCallback(() => {
        setOpened(true);
    });
    const closeMenu = event_callback_hook_1.useEventCallback(() => {
        setOpened(false);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { ref: anchorRef, variant: "contained", color: "primary", onClick: openMenu, disableElevation: true, className: clsx_1.default(classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.userButton), startIcon: react_1.default.createElement(Person_1.default, { className: classes.personIcon }) }, user === null || user === void 0 ? void 0 : user.name),
        react_1.default.createElement(Menu_1.default, { getContentAnchorEl: null, anchorEl: anchorRef.current, open: opened, onClose: closeMenu, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, PaperProps: {
                className: clsx_1.default(classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.userMenu),
            }, MenuListProps: {
                disablePadding: true,
            } },
            actions.map((action, i) => (react_1.default.createElement(user_btn_item_1.UserBtnItem, { action: action, key: i, onClose: closeMenu }))),
            displayLogoutBtn && (react_1.default.createElement(user_btn_item_1.UserBtnItem, { action: {
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_BTN_LOGOUT", defaultMessage: "Odhl\u00E1sit" })),
                    action: logout,
                }, onClose: closeMenu })))));
}
exports.UserBtn = UserBtn;
//# sourceMappingURL=user-btn.js.map